<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-scroll"></i></span
    >{{ "DOQuery.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <div class="flex justify-content-end">
          <laas-search-form-parameter-group
            #parameterGroup
            [formName]="preferenceKey"
            [parameters]="searchParams"
            (parameterGroupChange)="parameterGroupChange($event)"
            (unBookmarked)="unBookmarked($event)"
          ></laas-search-form-parameter-group>
        </div>
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid formgrid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.DONumber" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="doNos"
                    [(ngModel)]="searchParams.doNos"
                    separator=","
                    (onAdd)="doNoChipsAdd($event)"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.Group" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="tenants"
                    [(ngModel)]="searchParams.tenants"
                    separator=","
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.LetterHeadComp" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    [options]="letterHeadOptions"
                    [(ngModel)]="searchParams.letterHeadOrgIds"
                    formControlName="letterHeadOrgId"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    optionLabel="legalEntityOUName"
                    optionValue="legalEntityOUCode"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.LoadOrderComp" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    [options]="orgIdsOptions"
                    [(ngModel)]="searchParams.orgIds"
                    formControlName="orgIds"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    optionLabel="legalEntityOUName"
                    optionValue="legalEntityOUCode"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.ShipOutComp" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    [options]="shipCorpsOptions"
                    [(ngModel)]="searchParams.shipCorps"
                    formControlName="shipCorps"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    optionLabel="legalEntityOUName"
                    optionValue="legalEntityOUCode"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.CustomerCode" | translate }}
                </div>
                <div class="block">
                  <laas-customer-dropdown
                    formControlName="consigneeKey"
                    [(ngModel)]="searchParams.consigneeKey"
                    [showToggleAll]="false"
                    [isMultiple]="true"
                    [showLabel]="false"
                    [divClass]="'field'"
                  ></laas-customer-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.TradeTerm" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    appendTo="body"
                    formControlName="incoTerm"
                    [(ngModel)]="searchParams.incoTerm"
                    [options]="incotermOptions"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.Priority" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    appendTo="body"
                    formControlName="priority"
                    [(ngModel)]="searchParams.priority"
                    [options]="priorityOptions"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  #etd
                  [title]="'DOQuery.Search.ETD'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'etd')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.DeliveryLocate" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="deliveryType"
                    [options]="deliveryTypeOptions"
                    [(ngModel)]="searchParams.deliveryType"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.DeliveryMode" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="dischargeType"
                    [(ngModel)]="searchParams.dischargeType"
                  />
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  #invoiceDt
                  [title]="'DOQuery.Search.InvoiceDT'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'invoiceDt')"
                  [showCustomTime]="true"
                  dateFormat="yy-mm-dd"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.InvoiceNumber" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="invoiceNos"
                    [(ngModel)]="searchParams.invoiceNos"
                    separator=","
                    (onAdd)="chipsAdd($event, 'invoiceNos')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.BOLCnt" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="bookingCount"
                    [(ngModel)]="searchParams.bookingCount"
                  />
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.SalesCode" | translate }}
                </div>
                <div class="block">
                  <laas-multiSelect
                    [options]="salesOptions"
                    [(ngModel)]="searchParams.salesCode"
                    appendTo="body"
                    [virtualScroll]="true"
                    [itemSize]="45"
                    formControlName="salesCode"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    filterBy="label"
                    [showToggleAll]="false"
                  >
                  </laas-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.DOStatus" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="status"
                    [options]="DOStatusOptions"
                    [(ngModel)]="searchParams.status"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.DOBookStatus" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="doBookingStatus"
                    [options]="DOBookingStatusOptions"
                    [(ngModel)]="searchParams.doBookingStatus"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.BookingNo" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="isBookingNoExist"
                    [options]="commonOptions"
                    [(ngModel)]="searchParams.isBookingNoExist"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.Facility" | translate }}
                </div>
                <div class="block">
                  <laas-facility-dropdown 
                    formControlName="selectedFacility" 
                    [isMultiple]="true" 
                    [showFilter]="true"
                    [showToggleAll]="true"
                    (onOptionDataChange)="optionsDataOnChange($event, 'selectedFacility')">
                  </laas-facility-dropdown> 
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.NoShippingReason" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="isNoShippingReasonExist"
                    [options]="commonOptions"
                    [(ngModel)]="searchParams.isNoShippingReasonExist"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.NormalizationAddressStatus" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="isNormalizationAddressMaintained"
                    [options]="commonOptions"
                    [(ngModel)]="searchParams.isNormalizationAddressMaintained"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.BookingForwarder" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="bookingForwarder"
                    optionLabel="optionDesc"
                    optionValue="optionCode"
                    [options]="bookingForwarderOptions"
                    [(ngModel)]="searchParams.bookingForwarder"
                    [filter]="true"
                    filterBy="optionDesc"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.DropType" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="dropType"
                    [options]="commonOptions"
                    [(ngModel)]="searchParams.dropType"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.ExtraWorkStatus" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="extraWorkStatus"
                    [options]="extraWorkStatusOptions"
                    [(ngModel)]="searchParams.extraWorkStatus"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.TaskCode" | translate }}
                </div>
                <div class="block">
                  <laas-multiSelect
                    [options]="taskCodeOptions"
                    [(ngModel)]="searchParams.taskCode"
                    [virtualScroll]="true"
                    [itemSize]="45"
                    appendTo="body"
                    formControlName="taskCode"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                    [showToggleAll]="false"
                  >
                  </laas-multiSelect>
                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.Creater" | translate }}
                </div>
                <div class="block">
                  <laas-multiSelect
                    [options]="createrOptions"
                    [(ngModel)]="searchParams.creater"
                    appendTo="body"
                    [virtualScroll]="true"
                    [itemSize]="45"
                    formControlName="creater"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                    [showToggleAll]="false"
                  >
                  </laas-multiSelect>
                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.MergeKey" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="mergeKeys"
                    [(ngModel)]="searchParams.mergeKeys"
                    separator=","
                    (onAdd)="chipsAdd($event, 'mergeKeys')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.IsConfirm" | translate }}
                </div>
                <div class="block mt-2">
                  <div class="formgroup-inline">
                    <div class="field-checkbox">
                      <p-checkbox
                        [binary]="true"
                        formControlName="isConfirm"
                        label="{{ 'DOQuery.Search.HaveMerge' | translate }}"
                        [(ngModel)]="searchParams.isConfirm"
                      ></p-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "DOQuery.Search.ConsolidationId" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="consolidationIds"
                    [(ngModel)]="searchParams.consolidationIds"
                    separator=","
                    (onAdd)="chipsAdd($event, 'consolidationIds')"
                  ></p-chips>
                </div>
              </div>

              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  #createDtMO
                  [title]="'DOQuery.Search.CreateDtMO'"
                  [defaultDate]="defaultCreateDtMO"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'createDtMO')"
                  [showCustomTime]="true"
                  dateFormat="yy-mm-dd"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <div class="block mb-1">{{ 'DOQuery.Search.FrontLineDocStatus' | translate }}</div>
                <p-multiSelect
                  formControlName="frontLineDocStatus"
                  [filter]="true"
                  [options]="frontLineDocStatusOptions"
                  [(ngModel)]="searchParams.frontLineDocStatus"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-multiSelect>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchBtnClick($event)"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
                (click)="resetBtnClick($event)"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        id="doSearchForShippingMainTable"
        [selectable]="true"
        [(selectedRows)]="selectedDORows"
        [dataKey]="'doNo'"
        [tableKey]="preferenceKey"
        (setPageSize)="setPageSize($event)"
        [defaultColumns]="columns"
        [value]="DORows"
        [loading]="isLoading"
        [lazy]="true"
        [rows]="pageInfo.pageSize"
        [totalRecords]="pageInfo.totalRecords"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        (selectedRowsChange)="selectedRowsChange($event)"
      >
        <ng-template pTemplate="caption">
          <div class="inline-block my-1">
            <button
              pButton
              pRipple
              icon="far fa-file-excel"
              [disabled]="DORows.length === 0"
              (click)="exportExcel($event)"
              class="p-button-success"
            ></button>
          </div>
          <ng-container *ngTemplateOutlet="calculateRegion"></ng-container>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'__function'">
                <span
                  *ngIf="
                    rowData.isDropRemark &&
                    (rowData.cartonCnt === null || rowData.cartonCnt <= 0)
                  "
                  class="icon"
                >
                  <i
                    class="fas fa-exclamation-circle"
                    style="color: red"
                    pTooltip="Need to Be Maintained Carton Count"
                  ></i>
                </span>
                <span
                  *ngIf="rowData.isDropRemark"
                  class="icon"
                  (click)="editBtnClick($event, rowData)"
                  ><i class="fas fa-edit"></i
                ></span>
                <span class="icon" (click)="reasonBtnClick($event, rowData)"
                  ><i class="fas fa-comment-alt"></i
                ></span>
                <span
                  class="icon"
                  *ngIf="isNeedMaintainAddress(rowData)"
                  (click)="addressBtnClick($event, rowData)"
                  ><i class="fas fa-map-pin"></i
                ></span>
              </ng-container>
              <ng-container *ngSwitchCase="'__download'">
                <button
                  pButton
                  pRipple
                  [label]="'Common.Button.FileUpload' | translate"
                  class="p-button-outlined p-button-help"
                  (click)="fileBtnClick($event, rowData)"
                ></button>
              </ng-container>
              <ng-container>
                <ng-container *ngSwitchCase="'doNo'">
                  <div class="overflow-text">
                    <a
                      href="javascript: void(0);"
                      (click)="doNoLinkClick($event, rowData)"
                      >{{ rowData[col.field] }}</a
                    >
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'letterHeadOrgId'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : orgIdList
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'shipCorp'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : orgIdList
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'orgId'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : orgIdList
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'incoTerm'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : incotermOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'doStatus'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : DOStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'doBookingStatus'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : DOBookingStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'priority'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : priorityOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'shipNotes'">
                  <div class="overflow-text">
                    <a href="javascript: void(0);" (click)="shippingNotesClick($event, rowData)">{{
                      displayMessageArray(rowData[col.field]) | replaceNullWith:'-' }}</a>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'etd'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'invoiceDate'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'eta'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'isConfirm'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : confirmStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'extraWorkStatus'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : extraWorkStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'frontLineDocStatus'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : frontLineDocStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'assignmentInvoiceDt'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'createDtMO'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <ng-container [ngSwitch]="col.dataType">
                    <ng-container *ngSwitchCase="'date'">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm:ss"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith : "-"
                        }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'array'">
                      <ng-container
                        *ngIf="rowData[col.field].length > 0; else displayEmpty"
                      >
                        <div>
                          <ng-container
                            *ngFor="let note of rowData[col.field]; index as i"
                          >
                            <div class="overflow-text">
                              {{ i + 1 }}. {{ note + "\n" }}
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith : "-" }}
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #displayEmpty> - </ng-template>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
    <div class="mt-2 text-center">
      <button
        pButton
        pRipple
        label="{{ 'DOQuery.Button.CreateBooking' | translate }}"
        (click)="createBookingBtnClick($event)"
      ></button>
      <button
        pButton
        pRipple
        label="{{ 'DOQuery.Button.AutoBooking' | translate }}"
        (click)="autoBookingBtnClick($event)"
        class="p-button-secondary ml-2"
        [disabled]="selectedDORows.length > 0"
      ></button>
    </div>
  </p-card>
  <laas-dofile-management
    [display]="showDoFile"
    [doNo]="doNoFile"
    (onClose)="closeFile($event)"
  >
  </laas-dofile-management>
  <laas-address-management
    [display]="showAddressConfirm"
    [doNos]="confirmDos"
    (onClose)="closeAddressConfirm($event)"
    (onEditAddress)="reWriteDo($event)"
  >
  </laas-address-management>
</div>
<laas-drop-ctn-modiy
  *ngIf="selectedDO"
  [display]="isShowEditDOModal"
  [dropDO]="selectedDO"
  (modalClosed)="modalCancelBtnClick($event)"
></laas-drop-ctn-modiy>
<p-dialog
  header="{{ 'DOQuery.Search.NoShippingReasonEdit' | translate }}"
  [(visible)]="isShowReasonModal"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  [baseZIndex]="1000"
  [resizable]="false"
  [dismissableMask]="true"
  (onHide)="editModalHide($event)"
  [style]="{ width: '30%' }"
  [breakpoints]="{ '1024px': '60%', '800px': '75%', '550px': '90%' }"
>
  <div *ngIf="selectedDO">
    <div class="p-fluid formgrid mt-2">
      <div class="field grid">
        <label class="col-4">"{{ 'DOQuery.Search.NoShippingReason' | translate }}"</label>
        <div class="col-8">
          <p-dropdown
            [options]="noShippingReasonOptions"
            [(ngModel)]="selectedDO.noShippingReason"
            appendTo="body"
            [filter]="true"
            placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
            [baseZIndex]="10000"
            [showClear]="true"
            (keydown)="onDropdownKeydown($event)"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="grid mt-2">
      <div class="col text-center">
        <button
          pRipple
          pButton
          label="{{ 'Common.Button.Confirm' | translate }}"
          (click)="reasonModalConfirmBtnClick($event)"
        ></button>
        <button
          pRipple
          pButton
          label="{{ 'Common.Button.Cancel' | translate }}"
          class="p-button-secondary ml-2"
          (click)="reasonModalCancelBtnClick($event)"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>

<ng-template #calculateRegion>
  <div class="font-bold">
    {{ "DOQuery.Form.Title.TotalCartonCnt" | translate }}：{{
      selectedCartonsInfo.cartonCnt
    }}
    {{ "DOQuery.Form.Title.NetWeight" | translate }}：{{
      selectedCartonsInfo.totalNetWeight
    }}
    {{ "DOQuery.Form.Title.GrossWeight" | translate }}：{{
      selectedCartonsInfo.totalGrossWeight
    }}
    {{ "DOQuery.Form.Title.VolumeWeight" | translate }}：{{
      selectedCartonsInfo.volumeWeight
    }}
    {{ "DOQuery.Form.Title.Cbm" | translate }}：{{ selectedCartonsInfo.cbm }}
    {{ "DOQuery.Form.Title.Pieces" | translate }}：{{
      selectedCartonsInfo.pieces
    }}
    <ng-container *ngIf="isSameCurrencyCode">
      {{ "DOQuery.Form.Title.Price" | translate }}({{
        selectedCartonsInfo.currencyCode
      }})：{{ selectedCartonsInfo.price }}
    </ng-container>
    <ng-container *ngIf="!isSameCurrencyCode">
      {{ "DOQuery.Form.Title.Price" | translate }}：{{
        "DOQuery.Form.Title.CantShowCurrencyCode" | translate
      }}
    </ng-container>
  </div>
</ng-template>


<laas-shipping-notes *ngIf="showShippingNotes" (closeDialog)="closeShipNotesDialog($event)" [browserLanguage]="browserLanguage" [doNo]="this.shippingNotesDoNo"></laas-shipping-notes>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
